import { getFirebaseCollectionName } from 'hx-analytics/src/functions/url-lead-source/get-firebase-collection-name.helper';
export var firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};
export var firebaseDBBasePath = process.env.REACT_APP_FIREBASE_DB_BASE_PATH;
export var widgetName = getFirebaseCollectionName(process.env.REACT_APP_WIDGET_NAME);
var config = {
    firebaseConfig: firebaseConfig,
    firebaseDBBasePath: firebaseDBBasePath,
    widgetName: widgetName,
};
export default config;
